export default __webpack_public_path__ + "static/media/darkDislike.17bcec7a.svg";